import React, { ReactNode } from 'react';
import Header from './Header';
import { Box, SxProps, Theme } from '@mui/material';
import SideNav from './SideNav';
import BottomNav from './BottomNav';
import Footer from './Footer';
import { NotificationReminder } from '../components/notification/NotificationReminder';
// import bg from '../assets/images/bg.png';

const LayoutWrapperStyle: SxProps<Theme> = {
  background: 'linear-gradient(180deg, #F1F5F6 0%, #F1F5F6 100%)',
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100dvh',
};

const LayoutBodyStyle: SxProps<Theme> = {
  display: 'flex',
  flex: 1,
  flexDirection: { xs: 'column', md: 'row' },
  paddingTop: { xs: '61px', md: '78px' },
};

interface MainLayoutProps {
  children: ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  return (
    <>
      <Box sx={LayoutWrapperStyle}>
        <Header />
        <Box sx={LayoutBodyStyle}>
          <SideNav />
          <Box
            sx={{
              flex: 1,
              marginBottom: '0px',
              paddingLeft: { xs: 0, md: '221px' },
              // backgroundImage: `url(${bg})`,
              // backgroundPosition: 'center',
              // backgroundRepeat: 'repeat',
              // backgroundSize: 'auto 100vh',
            }}
          >
            {children}
          </Box>
          <BottomNav />
          <NotificationReminder />
        </Box>
      </Box>
      <Footer />
    </>
  );
};

export default MainLayout;
